export const DISTRACTIONS_ANATOMY_QUESTION = `What's your biggest distraction when learning?`

export const DISTRACTIONS_ANATOMY_OPTION_KEYS = [
  'first',
  'second',
  'third',
  'fourth',
  'fifth',
  'sixth',
] as const
